import { render, staticRenderFns } from "./StorageEmpty.vue?vue&type=template&id=5b6ec3dc&scoped=true&"
var script = {}
import style0 from "./StorageEmpty.vue?vue&type=style&index=0&id=5b6ec3dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6ec3dc",
  null
  
)

export default component.exports